import { MutedFilled, SoundFilled } from '@ant-design/icons';
import { ConfigProvider, Drawer, Menu } from 'antd';
import React, { useState } from 'react';
import Song from './Song';
import MusicPlayer from './MusicPlayer';

const songs = [
  {
      "key": "3EG9FJ0ToLfgnc1IG2Z1wz",
      "thumbnail": "https://i.scdn.co/image/ab67616d00004851696b4e67423edd64784bfbb4",
      "artist": "Tyler, The Creator",
      "track": "SWEET / I THOUGHT YOU WANTED TO DANCE (feat. Brent Faiyaz & Fana Hues)",
      "audio": "https://p.scdn.co/mp3-preview/d82ed534bd9772e180cd03bd5636de771ac2cf75?cid=a11ef3ca6993410887e0aa6489988876"
  },
  {
      "key": "5126a4VJeyOTo7HB1vXfpq",
      "thumbnail": "https://i.scdn.co/image/ab67616d00004851842b2c6c258fbaa254ff3b2c",
      "artist": "Alpha Wann",
      "track": "UNE MAIN LAVE L'AUTRE",
      "audio": "https://p.scdn.co/mp3-preview/541587df538f3c63e83a632918451126c0a6b526?cid=a11ef3ca6993410887e0aa6489988876"
  },
  {
    "key": "73eGiraiU7JkIsmFyQyJAv",
    "thumbnail": "https://i.scdn.co/image/ab67616d0000485178de8b28de36a74afc0348b5",
    "artist": "Kendrick Lamar",
    "track": "Real",
    "audio": "https://p.scdn.co/mp3-preview/c34cce055b661a638b7ba8729f2ae427a9d18c0e?cid=cfe923b2d660439caf2b557b21f31221"
},
{
  "key": "52ojopYMUzeNcudsoz7O9D",
  "thumbnail": "https://i.scdn.co/image/ab67616d000048519e1cfc756886ac782e363d79",
  "artist": "Tame Impala",
  "track": "New Person, Same Old Mistakes",
  "audio": "https://p.scdn.co/mp3-preview/5a899c2e48f474ac5cc4cd4472596f328331170a?cid=cfe923b2d660439caf2b557b21f31221"
},
{
  "key": "70BYuaBHAu0q4pfPLzF5qO",
  "thumbnail": "https://i.scdn.co/image/ab67616d00004851d3462d1395189dc76a326031",
  "artist": "Disclosure",
  "track": "F For You",
  "audio": "https://p.scdn.co/mp3-preview/17dd85f909a5ca21326194b5cbd17d0d9fd2ba8e?cid=cfe923b2d660439caf2b557b21f31221"
},
  {
      "key": "2kNKhCWc0UZ26mxh9bzXEF",
      "thumbnail": "https://i.scdn.co/image/ab67616d0000485195ec27252ac9553457a87adc",
      "artist": "Gnarls Barkley",
      "track": "Charity Case",
      "audio": "https://p.scdn.co/mp3-preview/63463f78c09e7706fa54f94c6a059dd59dd3f9aa?cid=a11ef3ca6993410887e0aa6489988876"
  },
  {
    "key": "3AM2ihc5RFzbC47eCpTg2I",
    "thumbnail": "https://i.scdn.co/image/ab67616d00004851fcd3724fba954e6104e4530d",
    "artist": "Joey Bada$$",
    "track": "Waves",
    "audio": "https://p.scdn.co/mp3-preview/dca0b4caef41fafb49a4a83320a341b9f70939a7?cid=a11ef3ca6993410887e0aa6489988876"
},
{
  "key": "2YIIDMcF9zWJ2xcFSA99lH",
  "thumbnail": "https://i.scdn.co/image/ab67616d000048519447198732c8fe9b12efcfb0",
  "artist": "ENNY",
  "track": "Charge It",
  "audio": "https://p.scdn.co/mp3-preview/432f5f6160965caa3f577113882dc0156b903353?cid=a11ef3ca6993410887e0aa6489988876"
},
  {
      "key": "5tqZJUHEuqdN12RZVq2l9p",
      "thumbnail": "https://i.scdn.co/image/ab67616d0000485160de86e634f2bd4d1364797e",
      "artist": "The Internet",
      "track": "Hold On",
      "audio": "https://p.scdn.co/mp3-preview/c01bb7e77b63fcff40c659db3e1257e72a95f0c5?cid=a11ef3ca6993410887e0aa6489988876"
  },
  {
    "key": "7fCuq8ehg7YwhiEszTKNqf",
    "thumbnail": "https://i.scdn.co/image/ab67616d000048517ca9ccbd6b25f0ac8e6ed197",
    "artist": "Joe James",
    "track": "A Painting",
    "audio": "https://p.scdn.co/mp3-preview/a5adde5bd562b57f4fc281a3d2dc8c3e85351dfa?cid=a11ef3ca6993410887e0aa6489988876"
},
  {
      "key": "4PEGwWH4tL6H7dGl4uVSPg",
      "thumbnail": "https://i.scdn.co/image/ab67616d00004851ee65bbd54f993b5f01d5c511",
      "artist": "Sade",
      "track": "Like a Tattoo",
      "audio": "https://p.scdn.co/mp3-preview/df80b312eb69e0babe9fa528e39ac13f960eb5c5?cid=a11ef3ca6993410887e0aa6489988876"
  },
  {
    "key": "5TxRUOsGeWeRl3xOML59Ai",
    "thumbnail": "https://i.scdn.co/image/ab67616d000048517005885df706891a3c182a57",
    "artist": "Tyler, The Creator",
    "track": "ARE WE STILL FRIENDS?",
    "audio": "https://p.scdn.co/mp3-preview/a964890412345dbd4686806312f6a074e089f385?cid=a11ef3ca6993410887e0aa6489988876"
},
  {
    "key": "4KiBIF4hfGxUILRZXzLDG4",
    "thumbnail": "https://i.scdn.co/image/ab67616d000048511918c3ba5a764d60004bcd67",
    "artist": "Josman",
    "track": "STOP! (Outro)",
    "audio": "https://p.scdn.co/mp3-preview/0d886582a933af683bbb5ea4a62563af1eb286d5?cid=a11ef3ca6993410887e0aa6489988876"
},
  {
      "key": "3DBFOXJKitLKUjlyOCX7ow",
      "thumbnail": "https://i.scdn.co/image/ab67616d00004851eddb2639b74ac6c202032ebe",
      "artist": "Kendrick Lamar",
      "track": "Chapter Six",
      "audio": "https://p.scdn.co/mp3-preview/70ffebd684c310eae44fc49d8beb2f0f75790127?cid=a11ef3ca6993410887e0aa6489988876"
  },
  {
      "key": "3xKsf9qdS1CyvXSMEid6g8",
      "thumbnail": "https://i.scdn.co/image/ab67616d00004851c5649add07ed3720be9d5526",
      "artist": "Frank Ocean",
      "track": "Pink + White",
      "audio": "https://p.scdn.co/mp3-preview/0e3ca894e19c37cbbbd511d9eb682d8bee030126?cid=a11ef3ca6993410887e0aa6489988876"
  },
  {
    "key": "0Wk1F7rr43ANfiyAgHZxOs",
    "thumbnail": "https://i.scdn.co/image/ab67616d0000485132113b7e16060337c9ff91d5",
    "artist": "2nd Exit",
    "track": "It's Alright",
    "audio": "https://p.scdn.co/mp3-preview/b68b4b969da7016524317f48a7219be8e48b5e27?cid=a11ef3ca6993410887e0aa6489988876"
},
  {
    "key": "4MXhiYIRDMGAuvZc5IFTwC",
    "thumbnail": "https://i.scdn.co/image/ab67616d00004851072e9faef2ef7b6db63834a3",
    "artist": "Travis Scott",
    "track": "ASTROTHUNDER",
    "audio": "https://p.scdn.co/mp3-preview/7400069aa1157e71455bf45fcbf29d897287b2a2?cid=a11ef3ca6993410887e0aa6489988876"
},
{
  "key": "1HibhNhwk2tljwC4BGGLXV",
  "thumbnail": "https://i.scdn.co/image/ab67616d000048517027294551db4fda68b5ddac",
  "artist": "Michael Jackson",
  "track": "I Can't Help It",
  "audio": "https://p.scdn.co/mp3-preview/cba7cb1ef854ad734819f8e2c56c21ed26e54574?cid=a11ef3ca6993410887e0aa6489988876"
},
  {
    "key": "3IGidq5qjagmNmwFsmNeIn",
    "thumbnail": "https://i.scdn.co/image/ab67616d00004851dad8074eb0c60a82d1d8973c",
    "artist": "Unknown Mortal Orchestra",
    "track": "Can’t Keep Checking My Phone",
    "audio": "https://p.scdn.co/mp3-preview/e521f6f53ec693ec545d077d89e843726806d5ab?cid=a11ef3ca6993410887e0aa6489988876"
},
{
  "key": "7LBdv0ek7Tj2s0bgxmlrC6",
  "thumbnail": "https://i.scdn.co/image/ab67616d000048514bb13f7847252cc829e05aa6",
  "artist": "Saba",
  "track": "CALLIGRAPHY",
  "audio": "https://p.scdn.co/mp3-preview/ec360c678e86de5d14e0181576ac91aa990f0ab3?cid=a11ef3ca6993410887e0aa6489988876"
},
{
  "key": "3RGvsWRnHFcxjhHOUWSlyv",
  "thumbnail": "https://i.scdn.co/image/ab67616d0000485157caa3c2ff658e7c72f81784",
  "artist": "Le Blaze",
  "track": "La cible (feat. Seak, Bvker & La Fève)",
  "audio": "https://p.scdn.co/mp3-preview/948d35aeb386c9be6949afac71cb86c01acfdd88?cid=a11ef3ca6993410887e0aa6489988876"
},
{
    "key": "4Hff1IjRbLGeLgFgxvHflk",
    "thumbnail": "https://i.scdn.co/image/ab67616d0000485119d85a472f328a6ed9b704cf",
    "artist": "Gorillaz",
    "track": "DARE",
    "audio": "https://p.scdn.co/mp3-preview/fb02aea39283e35a92f0ce79b67788b6b1e5ed51?cid=a11ef3ca6993410887e0aa6489988876"
}
];


const Playlist = ({setOpen, open }) => {

  const [currentSong, setCurrentSong] = useState('https://p.scdn.co/mp3-preview/01bd90753d380a512045134303a5e1f5a12de381?cid=a11ef3ca6993410887e0aa6489988878');

  const [isMuted, setIsMuted] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  const playlistStyle = {
    backgroundColor: 'rgba(17,17,17,0.9)'
  };

  const items = songs.map(s => {
    return {
      key: s.key,
      label: <Song track={s.track} artist={s.artist} thumbnail={s.thumbnail} />,
    };
  });

  const onClick = (e) => {
    setCurrentSong(songs.find(s => s.key === e.key));
  };

  const handleClick = () => {
    setIsMuted(!isMuted);
  };


  return (
    <ConfigProvider
    theme={{
      components: {
        Card: {
          bodyPadding: 10,
          colorBgContainer: 'rgba(191,191,191,0.17)',
          lineType: 'none'
        },
        Menu: {
          activeBarHeight: 90,
          itemHeight: 80,
          itemBg: 'none',
          itemSelectedBg: 'rgba(191,191,191,0.5)',
        }
      },
      token: {
        colorText: 'white',
        fontSizeLG: 24,
        colorIcon: 'white',
        colorIconHover:'#CCCCCC'

      },
    }}
    >
      <Drawer
      title='My Playlist'
      width={400}
      onClose={onClose}
      open={open}
      extra={isMuted ? <MutedFilled onClick={handleClick}/> : <SoundFilled onClick={handleClick}/>}
      style={playlistStyle}
    >
      <Menu
        style={{
          width: 360,
        }}
        mode="inline"
        items={items}
        onClick={onClick}
      />
      
    </Drawer>
    <MusicPlayer currentSong={currentSong} isMuted={isMuted} />
    </ConfigProvider>
  );
};

export default Playlist;